import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../../constants/common'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import {
  FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME,
  getFormikFormSelectFieldValidationSchema,
} from '../../Formik'

import {
  TASK_EDIT_TYPE_FIELDS_FIELD_NAME,
  TASK_EDIT_TYPE_FIELDS_INITIAL_VALUES,
} from './TaskEditTypeModal.constants'

export function getTaskEditTypeValidationSchema(t) {
  return Yup.object({
    [TASK_EDIT_TYPE_FIELDS_FIELD_NAME]:
      getFormikFormSelectFieldValidationSchema({
        notSelectedValueErrorText: t(
          'Error.TaskEditTypeNotSelectedValueFromListKey'
        ),
        objectPK: 'id',
        required: true,
      }),
  })
}

export function getTaskEditTypePayload(values) {
  return values[TASK_EDIT_TYPE_FIELDS_FIELD_NAME]?.id
    ? {
        [TASK_EDIT_TYPE_FIELDS_FIELD_NAME]:
          values[TASK_EDIT_TYPE_FIELDS_FIELD_NAME].id,
      }
    : EMPTY_OBJECT
}

export function getTaskEditTypeInitialValues() {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...TASK_EDIT_TYPE_FIELDS_INITIAL_VALUES,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
  }
}
